/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Team_Manager_Save_Group_FailedInputs */



/**
* | output |
* | --- |
* | "Error saving group. {error}" |
*
* @param {Team_Manager_Save_Group_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_save_group_failed = /** @type {((inputs: Team_Manager_Save_Group_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Save_Group_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur lors de l’enregistrement du groupe. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Speichern der Gruppe. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore durante il salvataggio del gruppo. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка сохранения группы. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al guardar el grupo. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`保存组时出错。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`グループの保存中にエラーが発生しました。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`समूह को सहेजने में त्रुटि। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Erro ao salvar o grupo. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Error saving group. ${i?.error}`)
});